export default function shortClientId(clientId: string) {
  return clientId.substring(0, 5);
}
